import { render, staticRenderFns } from "./ClassAttendances.vue?vue&type=template&id=0d036995&scoped=true"
import script from "./ClassAttendances.vue?vue&type=script&lang=js"
export * from "./ClassAttendances.vue?vue&type=script&lang=js"
import style0 from "./ClassAttendances.vue?vue&type=style&index=0&id=0d036995&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d036995",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VSkeletonLoader,VTooltip})
